<div style="margin-bottom: 8px;">
    <nb-select size="tiny" placeholder="Empresa" [(ngModel)]="empresaSelected">
        <nb-option *ngFor="let empresa of empresas" value="{{empresa.value}}">{{empresa.label}}</nb-option>
    </nb-select>

    <nb-select size="tiny" placeholder="Perfil" [(ngModel)]="perfilSelected">
        <nb-option *ngFor="let perfil of perfiles" value="{{perfil.value}}">{{perfil.label}}</nb-option>
    </nb-select>
    <!-- <nb-radio-group [(ngModel)]="flagActivo" >
        <nb-radio class="radioButton"
            *ngFor="let option of optAct"
            [value]="option.value">
            {{ option.label }}
        </nb-radio>
    </nb-radio-group> -->
    <button nbButton size="tiny" style="float: right;" class="buttontz" (click)="consultarUsuarios()">Buscar</button>
    <button nbButton size="tiny" style="float: right;" class="buttontz" (click)="crearUsuario()">
        <nb-icon icon="person-add-outline"></nb-icon>Crear Usuario
    </button>
</div>
<app-spinner *ngIf="showSpinner"></app-spinner>
<div *ngIf="showGrilla">
    <div *ngIf="!showSpinner">
        <!-- <angular-slickgrid gridId="gridUsuario" [columnDefinitions]="columnDefinitionsUsuarios"
            [gridOptions]="gridOptionsUsuarios" [dataset]="datasetUsuarios" gridHeight="380" gridWidth="100%"
            (onAngularGridCreated)="angularGridReady($event)">
        </angular-slickgrid> -->

        
     <ag-grid-angular
            #grilla1
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetUsuarios"
            [columnDefs]="columnDefinitionsUsuarios"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>
    </div>
</div>
<button nbButton size="tiny" style="float: right; margin-top: 5px; margin-bottom: 1%;" class="buttontz"
    [disabled]="deshabilitarExportUser" (click)="exportToExcelUsuarios()">
    <nb-icon icon="save-outline"></nb-icon>Exportar
</button>


<ng-template #newUsuarioOperador>
    <div style="height: 80px;">
        <app-nuevo-usuario-operador (cerrar)="hideModal($event)" (cerrarUpdate)="hideModalUpdate($event)">
        </app-nuevo-usuario-operador>
    </div>
</ng-template>

<ng-template #editUsuario>
    <div style="height: 80px;">
        <app-edit-usuario (cerrar)="hideModal($event)" (cerrarUpdate)="hideModalUpdate($event)" [datos]="dataParaEdit">
        </app-edit-usuario>
    </div>
</ng-template>

<ng-template #changePassword>
    <app-change-password (cerrar)="hideModal($event)" (cerrarUpdate)="hideModalUpdate($event)"
        [datos]="userToChangePass"> </app-change-password>
</ng-template>

<ng-template #MSJConfirmaCancelarDLT>
    <nb-card>
        <nb-card-header>
            Confirmación
        </nb-card-header>
        <nb-card-body>
            ¿Está seguro que desea eliminar el usuario?
        </nb-card-body>
        <nb-card-footer>
            <nb-card-footer>
                <app-spinner *ngIf="showSpinnerEliminar"></app-spinner>
                <button nbButton *ngIf="!showSpinnerEliminar" size="tiny" style="float: right; margin-top: 5px;"
                    class="buttontz" (click)="dltUsuario(usuarioAEliminar)">Sí<nb-icon nbPrefix icon="checkmark-outline"
                        pack="eva"></nb-icon></button>
                <button nbButton *ngIf="!showSpinnerEliminar" size="tiny" class="buttontz col-2 float-left margin-right"
                    (click)="hideModal('cerrar')">No<nb-icon nbPrefix icon="close-outline" pack="eva"></nb-icon>
                </button>
            </nb-card-footer>
        </nb-card-footer>
    </nb-card>
</ng-template>